// src/Components/Unsubscribe/UnsubscribeService.js

import {
  doc,
  writeBatch,
  collection,
  query,
  where,
  getDocs,
  getDoc,
} from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { db, functions } from '../../Firebase/firebase';

export const UnsubscribeService = {
  execute: async (users, options = { addToAudit: false, skipAuth: false }) => {
    const { addToAudit, skipAuth } = options;
    let successCount = 0;
    let failCount = 0;
    let failReason = '';

    const deletedDocPaths = new Set();

    for (const user of users) {
      if (!user.email) continue;
      const email = user.email.toLowerCase().trim();
      const uid = user.id;

      try {
        const batch = writeBatch(db);
        const safeDelete = (ref) => {
          if (!deletedDocPaths.has(ref.path)) {
            batch.delete(ref);
            deletedDocPaths.add(ref.path);
          }
        };

        // --- HARVEST COMPANY NAME ---
        let harvestedCompanyName = user.companyName || '';

        try {
          if (uid) {
            const mailDocRef = doc(db, 'mailingList', uid);
            const mailDocSnap = await getDoc(mailDocRef);
            if (mailDocSnap.exists() && mailDocSnap.data().companyName) {
              harvestedCompanyName = mailDocSnap.data().companyName;
            }
            safeDelete(mailDocRef);
          }

          const qMail = query(collection(db, 'mailingList'), where('email', '==', email));
          const mailSnap = await getDocs(qMail);
          mailSnap.forEach((d) => {
            if (!harvestedCompanyName && d.data().companyName) {
              harvestedCompanyName = d.data().companyName;
            }
            safeDelete(d.ref);
          });
        } catch (dbErr) {
          console.warn(
            `Could not completely harvest or delete mailingList for ${email}`,
            dbErr.message,
          );
        }

        // --- UNSUBSCRIBE REQUESTS LOGIC ---
        if (addToAudit) {
          try {
            const auditRef = doc(db, 'unsubscribeRequests', email);
            batch.set(auditRef, {
              email: email,
              userName: user.userName || 'Unknown',
              companyName: harvestedCompanyName,
              requestDate: new Date().toISOString(),
            });
          } catch (auditErr) {
            console.warn(
              `Could not add ${email} to unsubscribeRequests`,
              auditErr.message,
            );
          }
        }
        // Notice: If addToAudit is false, we do NOTHING. We completely ignore the collection.

        try {
          await batch.commit();
        } catch (commitErr) {
          console.warn(`Batch commit failed for ${email}`, commitErr.message);
        }

        // --- DELETES THE USER FROM FIREBASE AUTHENTICATION ---
        // Will only run if skipAuth is explicitly false (default behavior)
        if (!skipAuth) {
          try {
            const deleteUserByEmail = httpsCallable(functions, 'deleteUserByEmail');
            await deleteUserByEmail({ email: email });
          } catch (authError) {
            console.warn(
              `Auth deletion failed or skipped for ${email}:`,
              authError.message,
            );
          }
        }

        successCount++;
      } catch (error) {
        console.error(`Error unsubscribing ${email}:`, error);
        failCount++;
        failReason =
          error.code === 'permission-denied'
            ? 'Permission Denied.'
            : error.message || 'System Error';
      }
    }

    return { successCount, failCount, failReason };
  },
};
